"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useTimeline = () => {
    const [undoStack, setUndoStack] = (0, react_1.useState)([]);
    const [redoStack, setRedoStack] = (0, react_1.useState)([]);
    const addToUndoStack = (item, clearRedo) => {
        setUndoStack(prev => {
            const newStack = [...prev, item];
            return newStack;
        });
        if (clearRedo)
            setRedoStack([]);
    };
    const addToRedoStack = (item) => {
        setRedoStack(prev => {
            const newStack = [...prev, item];
            return newStack;
        });
    };
    const undo = () => {
        if (undoStack.length === 0)
            return;
        const lastItem = undoStack.at(-1);
        setUndoStack(prev => {
            const newStack = [...prev];
            newStack.pop();
            return newStack;
        });
        addToRedoStack(lastItem);
        return lastItem;
    };
    const redo = () => {
        if (redoStack.length === 0)
            return;
        const lastItem = redoStack.at(-1);
        setRedoStack(prev => {
            const newStack = [...prev];
            newStack.pop();
            return newStack;
        });
        addToUndoStack(lastItem);
        return lastItem;
    };
    return {
        addToUndoStack,
        undo,
        redo,
        isUndoStackEmpty: undoStack.length === 0,
        isRedoStackEmpty: redoStack.length === 0,
        clearTimeline: () => {
            setUndoStack([]);
            setRedoStack([]);
        }
    };
};
exports.default = useTimeline;
